import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-full-page',
  templateUrl: './print-full-page.component.html',
  styleUrls: ['./print-full-page.component.scss']
})
export class PrintFullPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/print-full-page/print-full-page.component.ts